// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__10Znf","unreadBadge":"styles_unreadBadge__Kfol1","modalContent":"styles_modalContent__1oNc5","modal":"styles_modal__1b6Is"};